import gql from "graphql-tag";

export default gql`
  mutation changeSourcePrivacy($sourceId: ID, $privacy: Boolean) {
    changeSourcePrivacy(sourceId: $sourceId, privacy: $privacy) {
      id
      privacyActivated
    }
  }
`;
